import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase/config';
import { apiClient } from './apiClient';
import { getErrorMessage } from '../utils/errors';

const PHONE_STORAGE_KEY = 'phoneForSignIn';

/**
 * Send SMS magic link to phone number
 */
export const sendSmsLink = async (phoneNumber: string): Promise<void> => {
  try {
    const response = await apiClient.post<{ success: boolean }>('/enpal-for-you/send-sms-link', {
      phoneNumber,
    });

    if (response.error) {
      throw new Error(response.error.message);
    }

    // Store phone number for verification
    window.localStorage.setItem(PHONE_STORAGE_KEY, phoneNumber);
  } catch (error) {
    throw new Error(`Errore nell'invio dell'SMS: ${getErrorMessage(error)}`);
  }
};

/**
 * Verify SMS magic link token and sign in with Firebase
 */
export const verifySmsLink = async (token: string): Promise<void> => {
  try {
    // Verify token with backend and get Firebase custom token
    const response = await apiClient.post<{ firebaseToken: string }>('/enpal-for-you/verify-sms', {
      token,
    });

    if (response.error) {
      throw new Error(response.error.message);
    }

    if (!response.data?.firebaseToken) {
      throw new Error('Token di autenticazione non ricevuto');
    }

    // Sign in with Firebase custom token
    await signInWithCustomToken(auth, response.data.firebaseToken);

    // Clear stored phone number
    window.localStorage.removeItem(PHONE_STORAGE_KEY);
  } catch (error) {
    throw new Error(`Verifica fallita: ${getErrorMessage(error)}`);
  }
};

/**
 * Get stored phone number (used during verification flow)
 */
export const getStoredPhone = (): string | null => {
  return window.localStorage.getItem(PHONE_STORAGE_KEY);
};

/**
 * Clear stored phone number
 */
export const clearStoredPhone = (): void => {
  window.localStorage.removeItem(PHONE_STORAGE_KEY);
};

// Legacy exports for backwards compatibility (deprecated)
export const getStoredEmail = getStoredPhone;

